import { ungzip } from 'pako';
import JSON5 from 'json5';

function parseJson(text: string): any {
  // Strip BOM and leading whitespace so we can reliably check the first
  // character. The previous implementation searched for the first occurrence
  // of '{' or '[' anywhere in the string which could accidentally match a
  // character in binary data (e.g. gzipped audio) and produce confusing
  // JSON parse errors.
  const cleaned = text.replace(/^\uFEFF/, '').trimStart();
  if (!cleaned.startsWith('{') && !cleaned.startsWith('[')) {
    // Decoded content does not appear to be JSON. This typically occurs when a
    // user accidentally provides a plain audio file instead of a beatstage
    // bundle. Detect a few common audio file headers to provide a clearer error
    // message.
    if (
      cleaned.startsWith('ID3') || // MP3
      cleaned.startsWith('OggS') || // OGG/Vorbis
      cleaned.startsWith('RIFF') || // WAV
      cleaned.startsWith('fLaC') // FLAC
    ) {
      throw new SyntaxError('Decoded data appears to be an audio file, not a beatstage bundle');
    }
    throw new SyntaxError('No JSON object found in decoded data');
  }
  try {
    return JSON.parse(cleaned);
  } catch {
    return JSON5.parse(cleaned);
  }
}

export async function decodeBundle(encoded: string): Promise<any> {
  console.log('[decodeBundle] encoded length', encoded.length);
  let bytes: Uint8Array;
  try {
    const binary = atob(encoded);
    bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  } catch (err) {
    console.error('[decodeBundle] base64 decode failed', err);
    throw err;
  }
  console.log('[decodeBundle] byte length', bytes.length);
  if (typeof DecompressionStream !== 'undefined') {
    try {
      const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
      const text = await new Response(stream).text();
      return parseJson(text);
    } catch (err) {
      console.warn('[decodeBundle] DecompressionStream failed', err);
      // fall through to manual decompression
    }
  }
  try {
    const decompressed = ungzip(bytes);
    const text = new TextDecoder().decode(decompressed);
    console.log('[decodeBundle] ungzip text length', text.length);
    return parseJson(text);
  } catch (err) {
    console.warn('[decodeBundle] ungzip or parse failed', err);
    const text = new TextDecoder().decode(bytes);
    console.log('[decodeBundle] fallback text length', text.length);
    return parseJson(text);
  }
}

